export default __webpack_public_path__ + "static/media/Bright Bonus Win.a7d2873a.mp3";